// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables(memberId) {
  return {
    memberId: memberId
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_node(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["DisplayOnlyMember"]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"node_DisplayOnlyMember":{"f":""},"node":{"u":"response_node"}}};

let wrapResponseConverterMap = {
  response_node: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"node_DisplayOnlyMember":{"f":""},"node":{"u":"response_node"}}};

let responseConverterMap = {
  response_node: unwrap_response_node
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "memberId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedEditDisplayOnlyMemberQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UnifiedEditDisplayOnlyMember_displayOnlyMember"
              }
            ],
            "type": "DisplayOnlyMember",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "UnifiedEditDisplayOnlyMemberQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "licenseNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfilePhoto",
                "kind": "LinkedField",
                "name": "profilePicture",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "ratio",
                        "variableName": "__relay_internal__pv__DevicePixelRatio"
                      },
                      {
                        "kind": "Literal",
                        "name": "width",
                        "value": 96
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketingProfileSocialAccounts",
                "kind": "LinkedField",
                "name": "socialAccounts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "twitter",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "facebook",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "instagram",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkedIn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "youTube",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tikTok",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "yelp",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "DisplayOnlyMember",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6a4dca39be0b5f534f1f9949dd7d60eb",
    "id": null,
    "metadata": {},
    "name": "UnifiedEditDisplayOnlyMemberQuery",
    "operationKind": "query",
    "text": "query UnifiedEditDisplayOnlyMemberQuery(\n  $memberId: ID!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  node(id: $memberId) {\n    __typename\n    ... on DisplayOnlyMember {\n      ...UnifiedEditDisplayOnlyMember_displayOnlyMember\n    }\n    nodeId\n  }\n}\n\nfragment UnifiedDisplayOnlyMemberInformationForm_displayOnlyMember on DisplayOnlyMember {\n  firstName\n  lastName\n  licenseNumber\n  title\n  bio\n  nodeId\n}\n\nfragment UnifiedDisplayOnlyMemberPhotoForm_changeProfilePhoto_displayOnlyMember on DisplayOnlyMember {\n  nodeId\n}\n\nfragment UnifiedDisplayOnlyMemberPhotoForm_currentPhoto_displayOnlyMember on DisplayOnlyMember {\n  profilePicture {\n    url(width: 96, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n\nfragment UnifiedDisplayOnlyMemberPhotoForm_displayOnlyMember on DisplayOnlyMember {\n  firstName\n  displayName\n  ...UnifiedDisplayOnlyMemberPhotoForm_currentPhoto_displayOnlyMember\n  ...UnifiedDisplayOnlyMemberPhotoForm_changeProfilePhoto_displayOnlyMember\n}\n\nfragment UnifiedDisplayOnlyMemberSocialAccountsForm_displayOnlyMember on DisplayOnlyMember {\n  nodeId\n  firstName\n  displayName\n  socialAccounts {\n    twitter\n    facebook\n    instagram\n    linkedIn\n    youTube\n    tikTok\n    yelp\n  }\n}\n\nfragment UnifiedEditDisplayOnlyMember_displayOnlyMember on DisplayOnlyMember {\n  nodeId\n  displayName\n  ...UnifiedDisplayOnlyMemberInformationForm_displayOnlyMember\n  ...UnifiedDisplayOnlyMemberPhotoForm_displayOnlyMember\n  ...UnifiedDisplayOnlyMemberSocialAccountsForm_displayOnlyMember\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

let wrap_response_node = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_node = unwrap_response_node;
exports.wrap_response_node = wrap_response_node;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
